"use client"

import { useAuth } from "@/lib/auth-context"
import { AlertTriangle, Clock } from "lucide-react"

function getTimeRemaining(endsAt: string): { days: number; hours: number; total: number } {
  const diff = new Date(endsAt).getTime() - Date.now()
  if (diff <= 0) return { days: 0, hours: 0, total: 0 }
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    total: diff,
  }
}

export function TrialBanner() {
  const { user } = useAuth()

  if (!user || user.isSuperAdmin) return null
  if (user.tenantStatus !== "trial" || !user.trialEndsAt) return null

  const remaining = getTimeRemaining(user.trialEndsAt)

  if (remaining.total <= 0) {
    return (
      <div className="flex items-center gap-2 border-b border-red-200 bg-red-50 px-6 py-2 text-sm text-red-700 dark:border-red-900 dark:bg-red-950 dark:text-red-400">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span className="font-medium">Trial Expired</span>
        <span className="text-red-600 dark:text-red-400">
          Your trial has ended. Some features may be limited. Contact support to upgrade.
        </span>
      </div>
    )
  }

  const message =
    remaining.days > 0
      ? `${remaining.days}d ${remaining.hours}h remaining`
      : `${remaining.hours}h remaining`

  return (
    <div className="flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-6 py-2 text-sm text-amber-700 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-400">
      <Clock className="h-4 w-4 shrink-0" />
      <span className="font-medium">Trial Version</span>
      <span className="text-amber-600 dark:text-amber-400">{message}</span>
    </div>
  )
}
